<template>
  <modal-component v-if="open" :on-process="onLeave" :on-cancel="onStay"
                   on-process-title="general.unsaved_changes_leave" on-cancel-title="general.unsaved_changes_stay">
    <template v-slot:header>{{ $t('general.unsaved_changes_title') }}</template>
    {{ $t('general.unsaved_changes_text') }}
  </modal-component>
</template>

<script>
import ModalComponent from "@/components/modals/ModalComponent";

// Confirmación para salir con cambios sin guardar; se usa con `useUnsavedChanges`.
export default {
  name: "UnsavedChangesModal",
  components: {
    ModalComponent
  },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  emits: ['leave', 'stay'],
  methods: {
    onLeave() {
      this.$emit('leave')
    },
    onStay() {
      this.$emit('stay')
    }
  }
}
</script>
